module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.messageClasses
  }, [(_vm.dismissable) ? _c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        this.show = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2c5d6bd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/croud-vue-semantic/src/Message.vue
// module id = 1449
// module chunks = 1